import {financeAPI} from "../../axios";

export const state = {
    isAccountClassLoading: false
}
export const mutations = {
    SET_IS_ACCOUNT_CLASS_LOADING(state, data)
    {
        state.isAccountClassLoading = data;
    }
}
export const actions = {
    getSingleAccountClassification(context, id)
    {
        return financeAPI.get(`AccountClass/${id}`);
    },
    createAccountClassification(context, data)
    {
        return financeAPI.post("AccountClass/Create", data);
    },
    updateAccountClassification(context, {id, data})
    {
        return financeAPI.put(`AccountClass/Update/${id}`, data);
    },
    deleteAccountClassification(context, id){
        return financeAPI.delete(`AccountClass/${id}`);
    },
    getAllAccountClassifications(){
        return financeAPI.get("AccountClass/All");
    }
}
export const getters = {}